<template>
  <div class="main" id="Informations">
    <Header :From="'Profile'" id="Header" />
    <CContainer class="d-flex content-center min-vh-90">
      <div class="row p-0 m-0">
        <div class="col-lg-4 col-md-4 col-sm-12"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 p-0 m-0 box account-box">
          <div class="title">
            <img src="/icons_2/prev.png" alt="" @click="$router.go(-1)" />
            <span>
              {{ $t("ShopProfile.ManageAccount") }}
            </span>
          </div>
          <div class="options">
            <div class="load" v-if="loading">
              <CIcon name="cil-cart" height="48" />
            </div>
            <div class="profile">
              <p class="subtitle">{{ $t("ShopProfile.Account") }}:</p>
              <CInput
                v-model="user.name"
                :placeholder="$t('Auth.NameLastName')"
                autocomplete="name"
              >
                <template #prepend-content><CIcon name="cil-user"/></template>
              </CInput>
              <!-- <CInput v-model="user.phone" :placeholder="$t('Auth.Phone')" autocomplete="phone" >
                    <template #prepend-content><CIcon name="cil-phone"/></template>
                </CInput> -->
              <div style="margin-bottom: 20px">
                <VuePhoneNumberInput
                  v-model="user.phone"
                  :default-country-code="selectedCountryIsoCode"
                  :show-code-on-list="false"
                  :translations="translations"
                  :disabled="optForVerification"
                  :border-radius="0"
                  :onlyCountries="preferredCountries"
                  @update="countrySelectorCallback"
                />
              </div>
              <CInput
                v-model="user.email"
                :placeholder="$t('Auth.Email')"
                autocomplete="email"
              >
                <template #prepend-content
                  ><CIcon name="cil-envelope-closed"
                /></template>
              </CInput>
              <CRow class="text-left mb-2">
                <CCol col="12">
                  <label for="Age">{{ $t("Auth.AgeGroup") }}</label>
                  <select
                    id="Age"
                    :placeholder="$t('Auth.AgeGroup')"
                    v-model="user.age"
                    style="width: 100%;border: 1px solid #ddd;height:30px;border-radius:5px;padding: 0 5px;"
                  >
                    <option value="All" selected>{{
                      $t("Auth.AgeAll")
                    }}</option>
                    <option value="13-19">13-19</option>
                    <option value="20-29">20-29</option>
                    <option value="30-39">30-39</option>
                    <option value="40-49">40-49</option>
                    <option value="50+">50+</option>
                  </select>
                </CCol>
                <!-- <CCol col="4" class="bold" style="margin-top: 10px;">Votre sexe: </CCol>
                    <CCol col="4" style="margin-top: 10px;">
                        <CInputRadio label="Homme" type="radio" value="M" name="gender" v-model="gender"></CInputRadio>
                    </CCol>
                    <CCol col="4" style="margin-top: 10px;">
                        <CInputRadio label="Femme" type="radio" value="F" name="gender" v-model="gender"></CInputRadio>
                    </CCol> -->
              </CRow>

              <CRow style="margin-top: 10px;" @click="edit()">
                <CCol col="12" class="text-left mt-4">
                  <CButton
                    type="submit"
                    color="primary"
                    class="px-4 w-100"
                    style=" background: #ef86c1; border-color: #ef86c1; "
                    >{{ $t("Button.UpdateAccount") }}</CButton
                  >
                </CCol>
              </CRow>
            </div>
          </div>
        </div>
      </div>
    </CContainer>
  </div>
</template>

<script>
import { userService } from "../../../_services";
import Header from "../../../components/Header.vue";

export default {
  name: "Swiper",
  components: {
    Header,
  },
  data: () => ({
    preferredCountries: ["TN", "SA", "AE"],
    selectedCountryIsoCode: "TN",
    translations: {
      countrySelectorLabel: "Code pays",
      countrySelectorError: "Choisir un pays",
      phoneNumberLabel: "Numéro de téléphone",
      example: "Exemple :",
    },
    optForVerification: false,
    phone_prefix: null,
    phoneNumber: "",
    loading: false,
    user: {
      name: "",
      phone: "",
      email: "",
      age: "",
      prefix: null,
    },
    offset: 0,
    collapsePrefences: true,
    collapseAccount: false,
  }),
  created() {
    this.user = JSON.parse(localStorage.getItem("shop_user"));
  },
  methods: {
    countrySelectorCallback(data) {
      console.log(data);
      this.user.prefix = "+" + data.countryCallingCode;
      this.phoneNumber = data.nationalNumber;
      this.selectedCountryIsoCode = data.countryCode;
      this.validPhoneNumber = data.isValid;
    },
    edit() {
      let loader = this.$loading.show();
      // vuephoneinput gives back number with spaces so we override it with one without
      this.user.phone = this.phoneNumber;
      userService
        .updateProfile(this.user)
        .then(
          function(data) {
            localStorage.removeItem("shop_user");
            localStorage.setItem("shop_user", JSON.stringify(this.user));
            this.$toast.success(this.$t("Toast.AccountUpdated"));
            this.$router.go(-1);
          }.bind(this)
        )
        .catch(
          function() {
            this.$toast.error(this.$t("Toast.AccountError"));
          }.bind(this)
        )
        .finally(
          function() {
            loader.hide();
          }.bind(this)
        );
    },
  },
};
</script>
<style lang="scss" scoped>
#Informations {
  .account-box {
    background: #fff;
    height: 100vh;
  }
  .box {
    background: #fff;
    width: 100%;
    width: 50vw;
    margin-top: 70px !important;
    margin-left: 15px !important;
    box-shadow: 0 0 8px 1px #ddd;
    margin-bottom: 30px !important;
  }

  .title {
    letter-spacing: 2px;
    font-size: 20px;
    padding: 10px;
    border-bottom: 2px solid #ddd;
    color: #666;
  }
  .title img {
    float: left;
    width: 30px;
    margin-top: 5px;
  }
  .options {
    text-align: left;
  }
  .subtitle {
    font-size: 15px;
    letter-spacing: 1px;
    font-weight: bold;
    display: block;
    padding: 0 0 0 10px;
    text-transform: uppercase;
    transition: 0.3s;
  }
  .profile {
    padding: 20px;
  }

  @media screen and (max-width: 720px) {
    .box {
      width: 100vw;
      max-width: 100vw;
      position: absolute;
      transform: translate(-50%);
      margin-top: 0px !important;
      box-shadow: 0 0 0 0 #ddd;
    }
    #Header {
      display: none;
    }
    .title {
      color: #ef86c1 !important;
    }
    .title img {
      display: inline-block;
    }
  }
}
</style>
